var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.item.label + "：", prop: _vm.item.prop } },
    [
      _vm.item.type === "remote-select"
        ? [
            _c(
              "el-select",
              _vm._b(
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: {
                    clearable: _vm.item.defaultValue === "",
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    "remote-method": _vm.getRemoteList,
                  },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                },
                "el-select",
                _vm.item.options || {},
                false
              ),
              _vm._l(_vm.remoteList, function (item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
          ]
        : _vm.item.type === "select"
        ? [
            _c(
              "el-select",
              _vm._b(
                {
                  attrs: { clearable: _vm.item.defaultValue === "" },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                },
                "el-select",
                _vm.item.options || {},
                false
              ),
              _vm._l(_vm.item.options.list || [], function (item, index) {
                return _c("el-option", {
                  key: index,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
          ]
        : _vm.item.type === "date"
        ? [
            _c(
              "el-date-picker",
              _vm._b(
                {
                  attrs: {
                    type: "date",
                    "value-format":
                      (_vm.item.options || {}).valueFormat || "yyyy-MM-dd",
                  },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                },
                "el-date-picker",
                _vm.item.options || {},
                false
              )
            ),
          ]
        : _vm.item.type === "dateRange"
        ? [
            _c(
              "el-date-picker",
              _vm._b(
                {
                  attrs: {
                    type: "daterange",
                    align: "right",
                    "value-format":
                      (_vm.item.options || {}).valueFormat || "yyyy-MM-dd",
                    "unlink-panels": "",
                    "range-separator": "-",
                  },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                },
                "el-date-picker",
                _vm.item.options || {},
                false
              )
            ),
          ]
        : _vm.item.type === "datetimeRange"
        ? [
            _c(
              "el-date-picker",
              _vm._b(
                {
                  attrs: {
                    type: "datetimerange",
                    align: "right",
                    "value-format":
                      (_vm.item.options || {}).valueFormat ||
                      "yyyy-MM-dd HH:mm:ss",
                    "default-time": ["00:00:00", "23:59:59"],
                    "unlink-panels": "",
                    "range-separator": "-",
                  },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                },
                "el-date-picker",
                _vm.item.options || {},
                false
              )
            ),
          ]
        : _vm.item.type === "user-select-input"
        ? [
            _c("UserSearchInput", {
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            }),
          ]
        : _vm.item.type === "input-number"
        ? [
            _c(
              "el-input-number",
              _vm._b(
                {
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                },
                "el-input-number",
                _vm.item.options || {},
                false
              )
            ),
          ]
        : [
            _c(
              "el-input",
              _vm._b(
                {
                  attrs: { clearable: "" },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                },
                "el-input",
                _vm.item.options || {},
                false
              )
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }